// text-encoder is a large polyfill for TextEncoder & TextDecoder, but all
// the browsers we care about support it natively.

module.exports = {
  TextEncoder,
  TextDecoder
};
